'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var index_es = require('../../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
var React = require('react');
var NoStyleButton_web = require('../../../atoms/NoStyleButton/NoStyleButton.web.cjs');
var Tooltip_web = require('../../../atoms/Tooltip/Tooltip.web.cjs');
var Typography_web = require('../../../atoms/Typography/Typography.web.cjs');
var useTextTruncation = require('../../../../utils/hooks/useTextTruncation.cjs');
var ChipContext = require('../context/ChipContext.cjs');
var Item_web_styles = require('./Item.web.styles.cjs');

/**
 * A chip item component for displaying chips.
 *
 * @scope Core
 */ const Item = ({ children, disabled = false, value, ...props })=>{
    const theme = react.useTheme();
    const [isRemoving, setIsRemoving] = React.useState(false);
    const { textWrapperRef, isTextTruncated } = useTextTruncation.useTextTruncation();
    const { variant, selectedValues, onSelectionChange, disabled: chipGroupDisabled, isFilterableItem, onRemove } = ChipContext.useChipContext();
    const isSelected = React.useMemo(()=>{
        if (variant === "single") {
            return selectedValues === value;
        }
        return Array.isArray(selectedValues) && selectedValues.includes(value);
    }, [
        variant,
        selectedValues,
        value
    ]);
    const chipItemStyles = React.useMemo(()=>[
            Item_web_styles.chipItemBase,
            Item_web_styles.chipVariant[variant](theme, isSelected),
            isFilterableItem && Item_web_styles.filterChipItem
        ], [
        theme,
        isSelected,
        variant
    ]);
    const role = React.useMemo(()=>{
        if (isFilterableItem) return "button";
        return variant === "single" ? "radio" : "checkbox";
    }, [
        variant,
        isFilterableItem
    ]);
    const handleClick = React.useCallback(()=>{
        if (!disabled) {
            if (isFilterableItem && onRemove) {
                setIsRemoving(true);
                // Wait for animation to complete before calling onRemove
                setTimeout(()=>{
                    onRemove?.(value);
                }, 200); // Match animation duration
            } else {
                onSelectionChange(value);
            }
        }
    }, [
        disabled,
        value,
        isFilterableItem,
        onRemove,
        onSelectionChange
    ]);
    const content = /*#__PURE__*/ jsxRuntime.jsxs(NoStyleButton_web.NoStyleButton, {
        disabled: disabled || chipGroupDisabled,
        customCss: [
            chipItemStyles
        ],
        "data-state": isSelected ? "on" : "off",
        role: role,
        "aria-label": value,
        onClick: handleClick,
        ...!isFilterableItem ? {
            "aria-checked": isSelected
        } : {
            "data-removing": isRemoving
        },
        ...props,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                variant: "footnote",
                fontWeight: "bold",
                ref: textWrapperRef,
                isTruncated: true,
                isMarginless: true,
                as: "span",
                customCss: Item_web_styles.chipItemText(theme, variant === "single" && isSelected),
                children: children
            }),
            isFilterableItem && /*#__PURE__*/ jsxRuntime.jsx(index_es.FontAwesomeIcon, {
                icon: index.faXmark,
                css: Item_web_styles.chipIcon
            })
        ]
    });
    // Only wrap in Tooltip if text is truncated and chip is filterable (Filter mode)
    return isTextTruncated && isFilterableItem ? /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
        tooltipContent: value,
        alignment: "top",
        children: content
    }) : content;
};
Item.displayName = "Chip.Item";

exports.Item = Item;
//# sourceMappingURL=Item.web.cjs.map
